module.exports = __webpack_public_path__ + "static/media/sprite.27adb94f.jpg";